/* eslint-disable react/no-multi-comp */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import Loader from 'components/common/Loader';
import { FSBTable } from 'components/common/FSBTable';
import { BIDS_QUERY } from './BillingDetailGraphQL';
import { bidsColumns, childBidsColumn } from './constants';

// const defaultFilters = {
//   filter: [
//     {
//       key: "offer",
//       value: "28",
//       type: "INT",
//       op: "EQ"
//     }
//   ],
//   pageNo: 1,
//   pageSize: 10,
// };
// const LastRow = ({ row, rows }) => {
//   const [updateBidStatus] = useMutation(UPDATE_BID_STATUS_MUTATION);
//   const { id } = row.original
//   const handleUpdateBidStatus = async (bidStatus) => {
//     try {
//       const { data } = await updateBidStatus({
//         variables: {
//           id,
//           bidStatus,
//           // isApproved,
//         },
//       });
//       console.log('Bid status updated:', data.updateBidStatus);
//     } catch (error) {
//       console.error('Error updating bid status:', error);
//     }
//   };
//   if (!rows || !rows?.length) return null
//   return <div>
//     <Button size='sm' color="danger" onClick={(e) => handleUpdateBidStatus("REJECT")}>Reject</Button>
//     <Button size='sm' color="primary" onClick={(e) => handleUpdateBidStatus("ACCEPT")}>Accept</Button>
//   </div>
// }
const ChildBids = ({ row }) => {
  const { childBids } = row.original;
  return (
    <FSBTable
      keyField="id"
      columns={childBidsColumn}
      data={childBids}
      totalCount={childBids.length}
      pagePerSize={childBids.length}
      // SubComponent={LastRow}// May use later
      search={false}
      pagination={false}
      isRowExpanded
      getRowCanExpand={() => true}
      showPagination={false}
    />
  );
};
const Bids = ({ id, status, bidType }) => {
  const [filters, setFilters] = useState({
    filter: [
      {
        key: bidType,
        value: id,
        type: 'INT',
        op: 'EQ',
      },
      {
        key: 'status',
        value: status,
        type: 'STRING',
        op: 'EQ',
      },
    ],
    pageNo: 1,
    pageSize: 10,
  });
  const { data, loading, error, refetch } = useQuery(BIDS_QUERY, {
    variables: { ...filters },
  });
  useEffect(() => {
    const allFilters = [...filters.filter];
    allFilters[0].value = id;

    refetch({
      ...filters,
      filter: [...allFilters],
    });
  }, [id]);

  // method for use of subscribeToMore
  if (loading) {
    return <Loader />;
  }

  if (error) return `There is an error on this page : ${error.message} `;
  if (!data?.bids?.bids) return 'Bids not found';
  const { totalCount, totalPages } = data?.bids || {};
  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };

  return (
    <>
      {/* Common data table to show users list*/}
      <FSBTable
        data={data?.bids?.bids}
        columns={bidsColumns}
        currentPageNo={filters.pageNo}
        pageSize={filters.pageSize}
        totalPages={totalPages || 0}
        totalCount={totalCount || 0}
        keyField="id"
        search={false}
        pagination={false}
        remote
        loading={loading}
        striped={false}
        hover={false}
        bordered={false}
        wrapperClass="table-responsive word-break"
        handlePageChange={handlePageChange}
        SubComponent={ChildBids}
        // defaultSorting={defaultSorting}

        isRowExpanded={false}
        getRowCanExpand={() => true}
      />
    </>
  );
};

export default Bids;
